import React, { useState, useEffect } from 'react';
import MapStyleAutocomplete from './MapStyleAutocomplete';
import './MapStyleDialog.css';

interface MapStyle {
  name: string;
  url: string;
  attribution: string;
}

const mapStyles: MapStyle[] = [
  {
    name: 'OpenStreetMap',
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  },
  {
    name: 'CartoDB Positron',
    url: 'https://basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
  },
  {
    name: 'CartoDB Dark Matter',
    url: 'https://basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
  },
  {
    name: 'ESRI World Imagery',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
  },
  {
    name: 'ESRI World Topo',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
  },
  {
    name: 'topo__',
    url: 'https://tile.tracestrack.com/topo__/{z}/{x}/{y}.webp?key=1b709dfd9bf9d55a7abcdefa375d69c1',
    attribution: '&copy; <a href="https://www.tracestrack.com">Tracestrack</a>'
  },
  {
    name: 'Tracestrack Topo Base Prod',
    url: 'https://tile.tracestrack.com/topo/{z}/{x}/{y}.webp?key=1b709dfd9bf9d55a7abcdefa375d69c1',
    attribution: '&copy; <a href="https://www.tracestrack.com">Tracestrack</a>'
  },
  {
    name: 'Tracestrack Carto Base Prod',
    url: 'https://tile.tracestrack.com/base/{z}/{x}/{y}.webp?key=1b709dfd9bf9d55a7abcdefa375d69c1',
    attribution: '&copy; <a href="https://www.tracestrack.com">Tracestrack</a>'
  },
  {
    name: 'terrain-rgb',
    url: 'https://tile.tracestrack.com/terrain-rgb/{z}/{x}/{y}.webp?key=1b709dfd9bf9d55a7abcdefa375d69c1',
    attribution: '&copy; <a href="https://www.tracestrack.com">Tracestrack</a>'
  },
  {
    name: '_',
    url: 'https://tile.tracestrack.com/_/{z}/{x}/{y}.webp?key=1b709dfd9bf9d55a7abcdefa375d69c1',
    attribution: '&copy; <a href="https://www.tracestrack.com">Tracestrack</a>'
  },
  {
    name: 'topo_nl',
    url: 'https://tile.tracestrack.com/topo_nl/{z}/{x}/{y}.webp?key=1b709dfd9bf9d55a7abcdefa375d69c1',
    attribution: '&copy; <a href="https://www.tracestrack.com">Tracestrack</a>'
  },
  {
    name: 'topo-nl-name',
    url: 'https://tile.tracestrack.com/topo-nl-name/{z}/{x}/{y}.webp?key=1b709dfd9bf9d55a7abcdefa375d69c1',
    attribution: '&copy; <a href="https://www.tracestrack.com">Tracestrack</a>'
  },
  {
    name: 'topo-_-name',
    url: 'https://tile.tracestrack.com/topo-_-name/{z}/{x}/{y}.webp?key=1b709dfd9bf9d55a7abcdefa375d69c1',
    attribution: '&copy; <a href="https://www.tracestrack.com">Tracestrack</a>'
  },
  {
    name: 'Tracestrack Topo-_-Name Prod',
    url: 'https://tile.tracestrack.com/topo-_-name/{z}/{x}/{y}.webp?key=1b709dfd9bf9d55a7abcdefa375d69c1',
    attribution: '&copy; <a href="https://www.tracestrack.com">Tracestrack</a>'
  },
  {
    name: 'Cache Server EN Name',
    url: 'https://ndev-cache.tracestrack.com/en-name/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server topo__',
    url: 'https://ndev-cache.tracestrack.com/topo__/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server Auto',
    url: 'https://ndev-cache.tracestrack.com/auto/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server topo__ @1x',
    url: 'https://ndev-cache.tracestrack.com/topo__/{z}/{x}/{y}@1x.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server topo_en',
    url: 'https://ndev-cache.tracestrack.com/topo_en/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server topo_fr',
    url: 'https://ndev-cache.tracestrack.com/topo_fr/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server topo_de',
    url: 'https://ndev-cache.tracestrack.com/topo_de/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server topo_nl',
    url: 'https://ndev-cache.tracestrack.com/topo_nl/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server en',
    url: 'https://ndev-cache.tracestrack.com/en/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server fr',
    url: 'https://ndev-cache.tracestrack.com/fr/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server de',
    url: 'https://ndev-cache.tracestrack.com/de/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server HU Name',
    url: 'https://ndev-cache.tracestrack.com/hu-name/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server HU Name 16',
    url: 'https://ndev-cache.tracestrack.com/hu-name-16/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Cache Server HE Name 16',
    url: 'https://ndev-cache.tracestrack.com/he-name-16/{z}/{x}/{y}.webp',
    attribution: 'Cache Server'
  },
  {
    name: 'Dev Server Topo Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/topo-_-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Default Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/_-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server EN Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/en-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Topo',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/topo/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Topo NL Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/topo-nl-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server HU Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/hu-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server ZH Hant Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/zh-Hant-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Base',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/base/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server ZH Hans Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/zh-Hans-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server FI Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/fi-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Bicycle Route',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/bicycle-route/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Bus Route',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/bus-route/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Train Route',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/train-route/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Subway Route',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/subway-route/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Landcover',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/landcover/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server RU Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/ru-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server FR Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/fr-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server DE Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/de-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server ES Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/es-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server IT Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/it-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server PL Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/pl-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server PT Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/pt-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server NL Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/nl-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server TR Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/tr-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server UK Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/uk-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server AR Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/ar-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Terrain RGB',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/terrain-rgb/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server JA Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/ja-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server KO Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/ko-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server SV Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/sv-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server TH Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/th-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server HE Name',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/he-name/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'Dev Server Overture Base',
    url: 'https://ndev-ondemand.tracestrack.com/ondemand/overture-base/{z}/{x}/{y}.webp',
    attribution: 'Dev Server'
  },
  {
    name: 'MapTiler Terrain RGB',
    url: 'https://api.maptiler.com/tiles/terrain-rgb-v2/{z}/{x}/{y}.webp?key=20IxhHmtSqzghnRtS2Ny',
    attribution: 'MapTiler'
  }
];

// Sentinel for "no layer": lets the optional third layer on the right map be switched off
const noneMapStyle: MapStyle = { name: 'None', url: '', attribution: '' };
const thirdLayerStyles: MapStyle[] = [noneMapStyle, ...mapStyles];

interface MapStyleDialogProps {
  isOpen: boolean;
  onClose: () => void;
  leftMapStyle: MapStyle;
  rightMapStyle: MapStyle;
  rightBaseMapStyle: MapStyle;
  rightThirdMapStyle: MapStyle;
  onLeftStyleChange: (style: MapStyle) => void;
  onRightStyleChange: (style: MapStyle) => void;
  onRightBaseStyleChange: (style: MapStyle) => void;
  onRightThirdStyleChange: (style: MapStyle) => void;
}

// Given a map style, if it points at a Dev Server ondemand tile endpoint,
// return that map's /reload URL on the gateway
// (e.g. https://ndev-ondemand.tracestrack.com/ctl/base/reload). The gateway serves every
// map from one host, so the URL is per map rather than per host.
const getDevServerReloadUrl = (style: MapStyle): string | null => {
  if (style.attribution !== 'Dev Server') return null;
  const match = style.url.match(/^(https?:\/\/[^/]+)\/ondemand\/([^/]+)\//);
  return match ? `${match[1]}/ctl/${match[2]}/reload` : null;
};

type ReloadStatus = 'idle' | 'loading' | 'success' | 'error';

const MapStyleDialog: React.FC<MapStyleDialogProps> = ({
  isOpen,
  onClose,
  leftMapStyle,
  rightMapStyle,
  rightBaseMapStyle,
  rightThirdMapStyle,
  onLeftStyleChange,
  onRightStyleChange,
  onRightBaseStyleChange,
  onRightThirdStyleChange
}) => {
  const [reloadStatus, setReloadStatus] = useState<Record<string, ReloadStatus>>({});

  const reloadUrls = Array.from(new Set(
    [leftMapStyle, rightBaseMapStyle, rightMapStyle, rightThirdMapStyle]
      .map(getDevServerReloadUrl)
      .filter((url): url is string => url !== null)
  ));

  const handleReload = async (url: string) => {
    setReloadStatus(prev => ({ ...prev, [url]: 'loading' }));
    try {
      // Dev servers typically don't send CORS headers; no-cors still lets us
      // detect an unreachable host via a rejected fetch.
      await fetch(url, { mode: 'no-cors' });
      setReloadStatus(prev => ({ ...prev, [url]: 'success' }));
    } catch (e) {
      setReloadStatus(prev => ({ ...prev, [url]: 'error' }));
    }
  };

  // Keep the drawer mounted while it plays its slide-out close animation
  const [shouldRender, setShouldRender] = useState(isOpen);

  useEffect(() => {
    if (isOpen) {
      setShouldRender(true);
      return;
    }
    const timeout = setTimeout(() => setShouldRender(false), 300);
    return () => clearTimeout(timeout);
  }, [isOpen]);

  // Close on Escape
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!shouldRender) return null;

  return (
    <div className={`dialog-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
      <div className={`dialog-content ${isOpen ? 'open' : ''}`} onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h2>Map Styles</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="dialog-body">
          {reloadUrls.length > 0 && (
            <div className="map-style-section">
              <h3>Reload</h3>
              {reloadUrls.map(url => {
                const status = reloadStatus[url] ?? 'idle';
                return (
                  <button
                    key={url}
                    className={`reload-button reload-button-${status}`}
                    onClick={() => handleReload(url)}
                    disabled={status === 'loading'}
                  >
                    <span className="reload-button-label">
                      {status === 'loading' ? 'Reloading…' : status === 'success' ? 'Reloaded' : status === 'error' ? 'Reload failed' : 'Reload'}
                    </span>
                    <span className="reload-button-url">{url}</span>
                  </button>
                );
              })}
            </div>
          )}

          <div className="map-style-section">
            <h3>Left Map Style</h3>
            <MapStyleAutocomplete
              mapStyles={mapStyles}
              value={leftMapStyle}
              onChange={onLeftStyleChange}
              placeholder="Select a map style for left map..."
            />

          </div>

          <div className="map-style-section">
            <h3>Right Map Style</h3>

            <h4 className="layer-sublabel">Base Layer</h4>
            <MapStyleAutocomplete
              mapStyles={mapStyles}
              value={rightBaseMapStyle}
              onChange={onRightBaseStyleChange}
              placeholder="Select a base layer for right map..."
            />

            <h4 className="layer-sublabel">Top Layer</h4>
            <MapStyleAutocomplete
              mapStyles={mapStyles}
              value={rightMapStyle}
              onChange={onRightStyleChange}
              placeholder="Select a top layer for right map..."
            />

            <h4 className="layer-sublabel">Third Layer</h4>
            <MapStyleAutocomplete
              mapStyles={thirdLayerStyles}
              value={rightThirdMapStyle}
              onChange={onRightThirdStyleChange}
              placeholder="Select a third layer for right map..."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { mapStyles, noneMapStyle };
export type { MapStyle };
export default MapStyleDialog;